class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
      if (window.vlbUpdateShippingTimer) window.vlbUpdateShippingTimer();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      if (window.vlbUpdateShippingTimer) window.vlbUpdateShippingTimer();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ].filter((section) => document.getElementById(section.id));
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* VLB shipping cutoff timer — robust global init. Runs on every page as a real external
   script (executes on iOS too) and refreshes the countdown whenever it appears in the DOM,
   including after the cart drawer lazy-mounts or re-renders on add/remove. Replaces the
   inline <script> that used to live in snippets/shipping-timer.liquid, which never executed
   inside the drawer lazy-mount template (the mobile-only failure). */
(function () {
  if (window.__vlbShippingTimer) return;
  window.__vlbShippingTimer = true;

  function chicagoNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
      weekday: 'short',
    }).formatToParts(new Date());
    var p = {};
    parts.forEach(function (x) {
      p[x.type] = x.value;
    });
    var hour = parseInt(p.hour, 10);
    if (hour === 24) hour = 0;
    return { hour: hour, minute: parseInt(p.minute, 10), second: parseInt(p.second, 10), weekday: p.weekday };
  }

  function updateAll() {
    var els = document.querySelectorAll('[data-shipping-timer]');
    if (!els.length) return;
    var c = chicagoNow();
    var nowSec = c.hour * 3600 + c.minute * 60 + c.second;
    var diff = 16 * 3600 + 30 * 60 - nowSec;
    var weekend = c.weekday === 'Sat' || c.weekday === 'Sun';
    els.forEach(function (el) {
      var timeEl = el.querySelector('.shipping-timer__time');
      var textEl = el.querySelector('.shipping-timer__text');
      if (!timeEl || !textEl) return;
      if (weekend || diff <= 0) {
        el.classList.add('shipping-timer--closed');
        textEl.innerHTML = 'Order now — processes next business day, <strong>guaranteed</strong>';
        return;
      }
      var h = Math.floor(diff / 3600);
      var m = Math.floor((diff % 3600) / 60);
      var s = diff % 60;
      timeEl.textContent = h > 0 ? h + 'h ' + m + 'm' : m + 'm ' + (s < 10 ? '0' + s : s) + 's';
    });
  }

  window.vlbUpdateShippingTimer = updateAll;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll);
  } else {
    updateAll();
  }
  setInterval(updateAll, 1000);
})();
